export default __webpack_public_path__ + "static/media/Logo-car.abac7eae.svg";